import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import { useEffect } from "react";
import { Tab } from "react-tabs";
import style from "./CategoryTab.module.css";
import Dummy from "components/Dummy";
import { useTouchClick } from "shared/hooks/useTouchClick"; // useTouchClick 훅 import
import LiquidGreyIcon from "resources/img/icons/LiquidGreyIcon";
import DeviceGreyIcon from "resources/img/icons/DeviceGreyIcon";
import DisposableGreyIcon from "resources/img/icons/DisposableGreyIcon";
import Inline from "layouts/container/Inline";
import Center from "layouts/wrapper/Center";

function CategoryTab2(props) {
    const { data, setFilteredProducts, onCategoryClick, selectedCategory } = props;
    const { handleTouchStart, handleTouchEnd } = useTouchClick(() => onCategoryClick(data.id), 50);

    const getIconColor = () => {
        return selectedCategory === data.id ? "white" : "#7B7B7B";
    };

    const renderCategoryIcon = () => {
        switch (data.categoryName) {
            case "입호흡":
                return <LiquidGreyIcon width="58" height="58" color={getIconColor()} />;
            case "기기":
                return <DeviceGreyIcon width="58" height="58" color={getIconColor()} />;
            case "일회용":
                return <DisposableGreyIcon width="58" height="58px" color={getIconColor()} />;
            default:
                return null;
        }
    };

    return (

            <div className={style.allBtn} onPointerDown={handleTouchStart} onPointerUp={handleTouchEnd}>
                <Center>
                    <Inline>
                        {renderCategoryIcon()}
                        <Dummy width="15px" />
                        <P
                            color={selectedCategory === data.id ? "white" : "#7B7B7B"}
                            weight={700}
                            font={"Pretendard"}
                            size={"1.8vw"}
                        >
                            {data.categoryName}
                        </P>
                    </Inline>
                </Center>
            </div>
       
    );
}

export default CategoryTab2;